function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512.568 512.568",
  width: "512",
  height: "512",
  stroke: "#000",
  strokeWidth: "10"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M255.284 325.284c-38.598 0-70-31.402-70-70s31.402-70 70-70 70 31.402 70 70-31.402 70-70 70zm0-100c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zM133.426 333.142l-76.858-76.858 76.858-76.858-28.284-28.284L0 256.284l105.142 105.142 28.284-28.284zm228 74.284l-28.284-28.284L256.284 456l-73.858-73.858-28.284 28.284 102.142 102.142 105.142-105.142zm151.142-151.142L410.426 154.142l-28.284 28.284L456 256.284l-74.858 74.858 28.284 28.284 103.142-103.142zM361.426 105.142L256.284 0 153.142 103.142l28.284 28.284 74.858-74.858 76.858 76.858 28.284-28.284z"
})));